import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SwMaskService } from '../../basic-components/sw-mask/sw-mask.service';
import { InstanceModuleService } from 'src/app/areas/kms/serves/instance/instance.module';
import { HttpClient } from '@angular/common/http';
import { GetUserModelService } from 'src/app/librarys/serves/public/get-user-model.service';
declare var $,XLSX;
@Component({
  selector: 'app-extract-task-config',
  templateUrl: './extract-task-config.component.html',
  styleUrls: ['./extract-task-config.component.css']
})
export class ExtractTaskConfigComponent implements OnInit {

  @ViewChild('modal') modal: SwModalframeComponent;    //弹出层组件
  @Input() param: any;
  @Output() callback = new EventEmitter(); //抛出事件
  // 是否导入实体清单
  isImportEntity = false;
  // 实体清单导入状态 0 未导入；1 导入完成；
  state = 0;
  // 实体清单数据
  datas:any = [];
  resourceDatas:any = [];
  userId: string;
  constructor(
    private http: HttpClient,
    private box: SwMassageBoxService,  //消息提示框
    private kmsService: KmsService,   //请求服务
    private jwt: SwJwtService,
    private swMaskService: SwMaskService,
    private instanceModuleService: InstanceModuleService,
    private User: GetUserModelService
  ) { 
  }

  ngOnInit() {
    let user = this.User.getUser();
    this.userId = user['userId'];
    this.queryExtractResourceList();
  }

  // 查询所有待提取的资源列表
  queryExtractResourceList(){
    this.resourceDatas = [];
    const params = {
      current: 1,
      size: 1000,
      userId: this.userId
    }
    this.kmsService.queryExtractResourceList(params).subscribe((res) => {
      if(res["code"] == "200"){
        this.resourceDatas = res["data"].records;
      }
    })
  }

  // 导入实体清单
  importEntityList(){
    document.getElementById('fileInput').click();
  }

  // 监听文件选择
  onFileChange(event: any) {
    const that = this;
    const files = event.target.files;
    if (files.length > 0) {  
      // 读取文件内容
      const reader = new FileReader();
      reader.onload = function (e) {
        if (e.target && e.target['result']) {
          // 确保得到的是 ArrayBuffer 类型的结果
          const data = e.target['result'] as ArrayBuffer;
          const workbook = XLSX.read(data, { type: 'array' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet, {
              header: 1, // 强制将第一行作为表头
              defval: null, // 处理空单元格
              raw: true // 保留原始值
          });
          that.datas = [];
          if(jsonData.length>1){
            jsonData.forEach((e,i) => {
              if(i>0 && e[0] && e[1]){
                that.datas.push({
                  instanceName: e[0],
                  conceptName: e[1]
                });
              }
            });
          }
          if(that.datas.length > 0){
            that.state = 1;
            that.box.success('导入完成!');
          }else{
            that.box.waring('导入数据为空!');
          }
        }
      };
      reader.readAsArrayBuffer(files[0]);
    }
  }

  // 创建任务
  createTask(){
    if(this.isImportEntity && this.datas.length == 0){
      this.box.waring('请先导入实体清单!');
      return;
    }
    this.modal.toggle();
    this.callback.emit(true);
    this.swMaskService.openMask('正在创建知识提取任务，请稍候...');
    // 获取任务编号
    this.kmsService.genKeTaskCode().subscribe((res) => {
      if(res.code == "200"){
        // 保存任务信息
        let taskId = this.instanceModuleService.uuid2();
        let params = {
          "contents": [],
          "instances": this.isImportEntity ? this.datas : [],
          "keTask": {
            "status": 1,  
            "taskId": taskId,
            "taskNum": res.data,
            "taskType": this.isImportEntity ? 0 : 1   // 0 根据导入实体清单提取； 1 自由提取
          }
        };
        this.resourceDatas.forEach(element => {
          params.contents.push({
            "materialId": element.materialId,
            "pagesNum": element.pagesNum,
            "taskId": taskId
          });
        });
        this.kmsService.saveKeTask(params).subscribe((res1) => {
          this.swMaskService.closeMask();
          if(res1.code == "200"){
            this.box.success('任务已创建成功,可前往知识提取页面查看提取进度!');
            // 清空已选的所有资源
            $('#selectedResourceNum').text(0);
            this.jwt.setToKen("selectedResourceNum",0);
            this.kmsService.removeAllExtractResources(this.userId).subscribe((res) => {});
          }else{
            this.box.waring('任务创建失败!');
          }
        })
      }else{
        this.swMaskService.closeMask();
        this.box.waring('获取任务编号失败!');
      }
    })
  }

  // 下载模板
  downloadExcel() {
    const templateUrl = '/assets/Images/entityImportTemplate.xls';
    this.http.get(templateUrl, { responseType: 'blob' }).subscribe(
      (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = '实体清单导入模板.xlsx'; // 设置文件名
        document.body.appendChild(a); // 添加到文档中，因为某些浏览器要求
        a.click(); // 触发点击事件
        a.remove(); // 下载完成后移除元素
        setTimeout(() => window.URL.revokeObjectURL(url), 0); // 释放 URL 对象
      },
      (error) => {
        console.error('下载文件时出错:', error);
      }
    );
  }
}
